import React from "react";
import HeaderScreenPresvalView from "./HeaderScreenPresvalView";

export default class HeaderScreenPresvalContainer extends React.Component {
    constructor(props) {
        super(props);
        this.CLASS_EXPANDED = "p-toggleable-content p-toggleable-content-enter-done";
        this.CLASS_NO_EXPANDED = "p-toggleable-content p-toggleable-content-collapsed p-toggleable-content-exit-done";
        this.ICON_EXPANDED = "pi pi-fw pi-angle-up";
        this.ICON_NO_EXPANDED = "pi pi-fw pi-angle-down";

        let isExpanded = props.isExpanded === undefined ? true : props.isExpanded;
        let withButtons = props.withButtons === undefined ? true : props.withButtons === "true";

        this.state = {
            contentClass: isExpanded ? this.CLASS_EXPANDED : this.CLASS_NO_EXPANDED,
            icon: isExpanded ? this.ICON_EXPANDED : this.ICON_NO_EXPANDED,
            hiddenContent: !isExpanded,
            withButtons: withButtons,
        };

        this.toggleFieldset = this.toggleFieldset.bind(this);
        this.executeSearch = this.executeSearch.bind(this);
    }

    toggleFieldset() {
        let hiddenContent = this.state.hiddenContent;
        if (this.props.onExpand && !hiddenContent) {
            this.props.onExpand();
        }
        this.setState({
            contentClass: hiddenContent ? this.CLASS_EXPANDED : this.CLASS_NO_EXPANDED,
            icon: hiddenContent ? this.ICON_EXPANDED : this.ICON_NO_EXPANDED,
            hiddenContent: !hiddenContent,
        });
    }

    executeSearch() {
        console.error("Si el botón buscar de fieldset está en true, debe contener la acción que ejecutará");
    }

    render() {
        const {contentClass, hiddenContent, expandedFieldset, icon} = this.state;

        return <HeaderScreenPresvalView
            headerTitle={this.props.headerTitle}
            menuIcon={this.props.menuIcon}
            buttonName={this.props.buttonName ? this.props.buttonName : "Filtros"}
            content={this.props.children}
            contentClass={contentClass}
            hiddenContent={hiddenContent}
            expandedFieldset={expandedFieldset}
            icon={icon}
            toggleFieldset={this.toggleFieldset}
            withButtons={this.state.withButtons}
            actionSearch={this.props.actionSearch ?
                this.props.actionSearch : this.props.executeSearch}
            disabledSearchButton={this.props.disabledSearchButton ? this.props.disabledSearchButton : false}
        />
    }
}